import { Patient, Doctor } from "@/types";
import { formatPatientId } from '@/lib/utils/patientId';

interface PrescriptionHeaderProps {
  patient: Patient;
  doctorName: string;
}

export function PrescriptionHeader({ patient, doctorName }: PrescriptionHeaderProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <h3 className="text-sm font-medium mb-2">Patient Information</h3>
        <div className="border rounded-md p-4">
          <p><span className="font-medium">Name:</span> {patient.name}</p>
          <p><span className="font-medium">Age:</span> {patient.age}</p>
          <p><span className="font-medium">Gender:</span> {patient.gender}</p>
          <p><span className="font-medium">ID:</span> {formatPatientId(patient.id)}</p>
        </div>
      </div>
      <div>
        <h3 className="text-sm font-medium mb-2">Doctor Information</h3>
        <div className="border rounded-md p-4">
          <p><span className="font-medium">Name:</span> {doctorName}</p>
          <p><span className="font-medium">Date:</span> {new Date().toLocaleDateString()}</p>
        </div>
      </div>
    </div>
  );
}
